export enum FilterParams {
    AttributeKeys = 'attributeKeys',
    CategoryId = 'categoryIds',
    Search = 'search',
    SupplierIds = 'supplierIds',
    BestPrice = 'isBestPrice',
    SpecialPrice = 'hasSpecialPrice',
    MinPrice = 'minPrice',
    MaxPrice = 'maxPrice',
    SortBy = 'sort',
    SortDirection = 'order',
    Page = 'page',
    PageSize = 'limit',
    SpecialOffer = 'specialOffer',
    Randomized = 'randomized',
    EcoProduct = 'isEcoProduct',
    CreatedAtFrom = 'createdAtFrom',
    CreatedAtUntil = 'createdAtUntil',
    OrderType = 'type',
    CustomerContactIds = 'customerContactIds',
    NormArticle = 'isNormArticle',
    Boosted = 'isPrioritizedInSearch',
    PreventImportDeletion = 'preventImportDeletion',
    CustomerContactId = 'customerContactId',
    CustomerAccountId = 'customerAccountId',
    AccountId = 'accountId',
    Status = 'status',
    SupplierAccountId = 'supplierAccountId',
    MaxPriceChangeRatio = 'maxPriceChangeRatio',
    RecipientAccountId = 'recipientAccountId',
    RecipientContactId = 'recipientContactId',
    ResponsibleContactId = 'responsibleContactId',
    SupplierId = 'supplierId',
    MainContact = 'isMain',
    ChargingSupplier = 'isChargingSupplier',
    ChangeState = 'changeState',
    Rating = 'rating',
    Classifications = 'classificationIds',
    InvoiceNumberSequenceId = 'invoiceNumberSequenceId',
    Scope = 'scope',
}

export enum SortDirection {
    Ascending = 'asc',
    Descending = 'desc',
}
